<template>
  <div class="home">
    <div class="wallpaper"></div>
    <div class="links-container">
      <ul>
        <li class="youtube">
          <a href="https://www.youtube.com/channel/UCKuANFr7P_Pv1CDp1AZzFYw">
            <font-awesome-icon :icon="['fab', 'youtube']" />
          </a>
        </li>
        <li class="facebook">
          <a href="https://facebook.com/offshorecoverband">
            <font-awesome-icon :icon="['fab', 'facebook-square']" />
          </a>
        </li>
        <li class="instagram">
          <a href="https://www.instagram.com/offshorecoverband/">
            <font-awesome-icon :icon="['fab', 'instagram']" />
          </a>
        </li>
        <li class="mail">
          <a href="mailto:offshoreband@hotmail.com">
            <font-awesome-icon icon="envelope" />
          </a>
        </li>
        <li class="phone">
          <a href="tel:0721431054">
            <font-awesome-icon icon="mobile-alt" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
export default {
  name: "home"
};
</script>

<style lang="scss" scoped>
@import "../styles/sections/home.scss";
</style>


